import { render } from "./Message.view.vue?vue&type=template&id=1c843836"
import script from "./Message.view.vue?vue&type=script&lang=js"
export * from "./Message.view.vue?vue&type=script&lang=js"

import "./Message.view.vue?vue&type=style&index=0&id=1c843836&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__